import { styled } from "@mui/material";

import Button from "../../../../../../components/Form/Button";

export const MainDiv = styled("div")(() => ({
  minHeight: "inherit",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  "& .MuiTableContainer-root": {
    overflowY: "hidden",
  },
}));

export const RowInputDiv = styled("div")(() => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
}));

export const StyledButton = styled(Button)(() => ({
  minWidth: "max-content",
}));
